<template>
  <div>
    <el-form ref="colForm" :model="col" :rules="rules" label-width="90px" class="demo-dynamic">
      <el-form-item label="列宽度" v-if="!isSimple">
        <el-input type="number" v-model="col.width" max="12" @blur="checkColWidth(col)" class="w-200"></el-input>
        <div class="form-tips">填n代表占表格宽度的n/12，最大可填12</div>
      </el-form-item>
      <el-form-item label="分组名称" v-if="!isSimple">
        <el-input v-model.trim="col.group_name" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="排序筛选开启" v-if="!isSimple">
        <el-radio-group v-model="col.is_sort">
          <el-radio class="radio" :label="1">是</el-radio>
          <el-radio class="radio" :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示内容">
        <el-radio class="radio" v-model="col.is_exit" :label="1">数据表字段</el-radio>
        <el-radio class="radio" v-model="col.is_summary" :label="1">汇总</el-radio>
        <el-radio class="radio" v-model="col.is_statistics" :label="1">统计运算</el-radio>
        <el-radio class="radio" v-model="col.is_php" :label="1">PHP语句</el-radio>
      </el-form-item>

      <!-- 数据表字段配置开始 -->
      <div v-if="fieldSelect">
        <el-form-item label="选择字段" prop="field_id">
          <!-- :filter-method="searchField" -->
          <el-select filterable v-model="col.field_id" placeholder="请选择字段" @change="changeField">
            <el-option
              v-for="item in filedOptions"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示名" prop="show_name">
          <el-input v-model="col.show_name" class="w-200"></el-input>
        </el-form-item>
      </div>
      <!-- 数据表字段配置结束 -->
      
      <!-- 汇总配置项开始 -->
      <div v-if="isSummary">
        <el-form-item label="关联表">
          <el-select v-model="col.summaryConfig.table_id" filterable placeholder="请选择关联表" @change="setFieldOption">
            <el-option
              v-for="item in tables"
              :label="item.name+item.title"
              :value="item.id">
              <span>{{ item.name }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联字段">
          <el-select v-loading="summaryLoading" filterable v-model="col.summaryConfig.relate_field_id" placeholder="请选择关联字段">
            <!--v-for="item in col.summaryConfig.foreign_option"-->
            <el-option
              v-for="item in col.summaryConfig.field_option"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="本表字段">
          <el-select filterable v-model="col.summaryConfig.marjor_field_id" placeholder="请选择本表字段" @change="summaryFieldChange">
            <el-option
              v-for="item in fieldsWithSubform"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇总字段">
          <el-select filterable v-loading="summaryLoading" v-model="col.summaryConfig.summary_field_id" placeholder="请选择汇总字段">
            <el-option
              v-for="item in col.summaryConfig.field_option"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索条件">
          <div class="form-tips lh-20">变量公式说明：Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后</div>
          <div class="m-b-10" v-for="(item, index) in col.summaryConfig.summary_condition">
            <el-select v-loading="summaryLoading" v-model="item.field_id" placeholder="汇总字段" class="w-120">
              <el-option
                v-for="item in col.summaryConfig.field_option"
                :label="item.field"
                :value="item.field_id">
              </el-option>
            </el-select>
            <el-select v-model="item.logic" class="w-80" placeholder="逻辑">
              <el-option
                v-for="option in logicTypes"
                :label="option.name"
                :value="option.id">
              </el-option>
            </el-select>
            <el-select v-model="item.type" class="w-80" placeholder="类型">
              <el-option
                v-for="option in typeOptions"
                :label="option.name"
                :value="option.id">
              </el-option>
            </el-select>
            <el-input v-model="item.value" class="w-80"></el-input>
            <el-button type="danger" size="small" @click="deleteSummaryCondition(index)">删除</el-button>
          </div>
          <el-button type="primary" @click="addSummaryCondition">添加</el-button>
        </el-form-item>
      </div>
      <!-- 汇总配置项结束 -->
      
      <!-- 统计运算配置项开始 -->
      <div v-if="isStatistics">
          <el-form-item label="统计方法">
            <el-radio-group v-model="col.statistics_configs.statistics_method">
              <el-radio label="10">求和</el-radio>
              <el-radio label="20">求总数</el-radio>
              <el-radio label="30">求平均</el-radio>
            </el-radio-group>
          </el-form-item>
         <el-form-item label="关联表">
          <el-select filterable  v-model="col.statistics_configs.table_id" placeholder="请选择关联表" @change="setFieldOption2">
            <el-option
              v-for="item in tables"
              :label="item.name+item.title"
              :value="item.id">
              <span>{{ item.name }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关联字段">
          <el-select filterable  v-loading="summaryLoading" v-model="col.statistics_configs.relate_field_id" placeholder="请选择关联字段">
            <el-option
              v-for="item in col.statistics_configs.field_option"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="本表字段">
          <el-select filterable  v-model="col.statistics_configs.marjor_field_id" placeholder="请选择本表字段">
            <el-option
              v-for="item in fields"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="统计字段">
          <el-select filterable  v-loading="summaryLoading" v-model="col.statistics_configs.statistics_field_id" placeholder="请选择统计字段">
            <el-option
              v-for="item in col.statistics_configs.field_option"
              :label="item.field+item.title"
              :value="item.field_id">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="搜索条件">
          <div class="m-b-10" v-for="(item, index) in col.statistics_configs.statistics_condition">
            <el-select v-loading="summaryLoading" v-model="item.field_id" placeholder="统计字段" class="w-120">
              <el-option
                v-for="item in col.statistics_configs.field_option"
                :label="item.field"
                :value="item.field_id">
              </el-option>
            </el-select>
            <el-select v-model="item.logic" class="w-80" placeholder="逻辑">
              <el-option
                v-for="option in logicTypes"
                :label="option.name"
                :value="option.id">
              </el-option>
            </el-select>
            <el-input v-model="item.value" class="w-80"></el-input>
            <el-button type="danger" size="small" @click="deleteStatisticsCondition(index)">删除</el-button>
          </div>
          <el-button type="primary" @click="addStatisticsCondition">添加</el-button>
        </el-form-item>

      </div>
      <!-- 统计运算配置项结束 -->
        
      <!-- PHP语言配置项开始 -->
      <div v-show="isPhp">
        <el-form-item label="运算语句">
          <el-input type="textarea" v-model="col.arithmetic"></el-input>
        </el-form-item>
      </div>
      <!-- PHP语言配置项结束 -->

      <el-form-item label="外键配置" v-if="fieldSelect && col.field_type == 120">
        <foreign-config :keyData="col.key_config" :keyList="keyList"></foreign-config>
      </el-form-item>
      

      <el-form-item v-if="!fieldSelect" label="字段名" prop="field_name">
        <el-input v-model="col.field_name" class="w-200"></el-input>
      </el-form-item>
      <el-form-item v-if="!fieldSelect" label="显示名" prop="show_name">
        <el-input v-model="col.show_name" class="w-200"></el-input>
      </el-form-item>


      <el-form-item label="是否链接" v-if="!isSimple">
        <el-checkbox-group v-model="col.deal_type">
          <el-checkbox v-for="item in dealTypes" :true-label="item.id" :false-label="0">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <!-- 跳转链接的配置项开始 -->
      <div v-for="(option, index) in col.link_option" v-show="showLinkConfig">
        <el-form-item label="参数">
          <el-select v-model="option.param" placeholder="请选择字段">
            <el-option
              v-for="item in fields"
              :label="item.field"
              :value="item.field">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实例">
          <el-input v-model="option.reality.name" class="w-180" :disabled="true" @change="realityChange(option)"></el-input>
          <el-button @click.prevent="openRealityDialog(index)">查找实例</el-button>
        </el-form-item>
        <el-form-item label="关联字段">
          <el-select filterable  v-model="option.fields" v-loading="loading" multiple placeholder="请选择" class="w-300">
            <el-option
              v-for="item in option.field_option"
              :label="item.field+item.title"
              :value="item.field">
              <span>{{ item.field }}（{{ item.title }}）</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="deleteLinkOption(index)" v-show="col.deal_type == LINK_SENDPARAMS">删除</el-button>
        </el-form-item>
      </div>
      <!-- 跳转链接的配置项结束 -->

      <!-- 下载配置项开始 -->
      <el-form-item label="选择下载链接字段" v-show="col.deal_type == LINK_DOWNLOAD">
        <el-select filterable  v-model="col.download_link" placeholder="请选择字段">
          <el-option
            v-for="item in fields"
            :label="item.field+item.title"
            :value="item.field">
            <span>{{ item.field }}（{{ item.title }}）</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 下载配置项结束 -->

      <!-- 链接区域结束 -->
      <el-form-item label="绑定权限规则" v-if="!isSimple">
        <el-input v-model="col.rule.name" class="w-180" :disabled="true"></el-input>
        <el-button size="small" @click.prevent="openRuleDialog()">查找</el-button>
        <el-button size="small" @click="clearRule()">清空</el-button>
      </el-form-item>


      <!-- <el-form-item label="是否下载操作">
        <el-radio class="radio" :disabled="disabledDown" v-model="col.is_down" :label="1">是</el-radio>
        <el-radio class="radio" v-model="col.is_down" :label="0">否</el-radio>
      </el-form-item>
      <el-form-item label="是否跳转">
        <el-radio class="radio" :disabled="disabledJump" v-model="col.is_jump" :label="1">是</el-radio>
        <el-radio class="radio" v-model="col.is_jump" :label="0">否</el-radio>
      </el-form-item> -->

      <el-form-item>
        <el-button size="small" @click="addLinkOption" v-show="col.deal_type == LINK_SENDPARAMS">添加链接配置</el-button>
      </el-form-item>
    </el-form>
    <rule-list ref="ruleList" @selectRule="selectRule"></rule-list>
    <reality-list ref="realityList" @selectReality="selectReality" :title="title"></reality-list>
  </div>
</template>

<script>
  import ruleList from '../../Common/business/rule.vue'
  import realityList from './reality.vue'
  import foreignConfig from './foreignConfig.vue'
  import http from '../../../assets/js/http'
  import modelConfig from '../../../config/modelConfig'
  import cmsConfig from '../../../config/cmsConfig'

  export default {
    name: 'colConfig',
    props: {
      listIndex: {
        type: Number,
        default() {
          return -1
        }
      },
      focusIndex: {
        type: Number,
        default() {
          return -1
        }
      },
      col: {
        type: Object,
        default() {
          return {}
        }
      },
      fields: {
        type: Array,
        default() {
          return []
        }
      },
      tables: {
        type: Array,
        default() {
          return []
        }
      },
      modelId: {
        type: Number,
        default() {
          return -1
        }
      },
      isSimple: { // 简化版
        type: Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return {
        link_name: '',
        listChange: false,
        beChange: false,
        loading: false,
        summaryLoading: false,      // 关联字段、汇总字段loading
        rules: {
          show_name: [
            { required: true, message: '请输入字段显示名', trigger: 'blur' }
          ],
          field_name: [
            { required: true, message: '请输入字段名', trigger: 'blur' }
          ]
        },
        keyOptions: [],
        keyList: [],
        logicTypes: [ // 逻辑数组
          { id: 'eq', name: '等于' },
          { id: 'neq', name: '不等于' },
          { id: 'gt', name: '大于' },
          { id: 'lt', name: '小于' },
          { id: 'elt', name: '小于等于' },
          { id: 'egt', name: '大于等于' }
        ],
        typeOptions: [
          { id: 10, name: '常量' },
          { id: 20, name: '时间变量' }
        ],
        summaryConditionModel: {
          field_id: '',
          logic: '',
          value: '',
          type: '',
          is_subform: 0
        },
        statisticsConditionModel: {
          field_id: '',
          logic: '',
          value: ''
        },
        dealTypes: [
          { id: 10, name: '下载' },
          { id: 20, name: '功能集跳转' },
          { id: 30, name: '传参给同页一级功能集' }
        ],
        linkOptionModel: {
          fields: [],
          fields_option: [],
          reality: {
            id: null,
            name: ''
          },
          param: ''
        },
        colIndex: -1,
        filedOptions: [],
        fieldsWithSubform: [] // 包含子表单的控件
      }
    },
    methods: {
      changeField(item) {
        if (this.listChange) {
          return
        }
        this.col.key_config = []
        _(this.fields).forEach((res) => {
          if (res.field_id == item) {
            this.col.show_name = res.title
            // this.col.field_id = res.field_id
            this.col.field_type = res.field_type
            if (res.field_type == 120) {
              let modelId = res.config.form_model ? res.config.form_model : this.modelId
              this.getKeyOptions(modelId, res.key_data)
              return
            } else {
              this.keyOptions = []
            }
            return
          }
        })
      },
      async getFields(id) {
        let arr = []
        let res = await this.apiGet(`cms/deals/all_fields/${id}`)
        return this.promiseHandler(arr, res)
      },
      async getFieldOption(model_id) {
        let arr = []
        this.summaryLoading = true
        let res = await this.apiGet(`cms/deals/fields/${model_id}`)
        this.summaryLoading = false
        return this.promiseHandler(arr, res)
      },
      async setFieldOption(model_id) {
        // if (!this.col.summaryConfig.field_option || !this.col.summaryConfig.field_option.length) {
        let arr = await this.getFieldOption(model_id)
        this.col.summaryConfig.field_option = arr
        this.col.summaryConfig.foreign_option = this.getForeignOption(arr)
        // }
      },
      async setFieldOption2(model_id) {
        // if (!this.col.statistics_configs.field_option || !this.col.statistics_configs.field_option.length) {
        let arr = await this.getFieldOption(model_id)
        this.col.statistics_configs.field_option = arr
        this.col.statistics_configs.foreign_option = this.getForeignOption(arr)
        // }
      },
      getForeignOption(arr) {
        let array = []
        _(arr).forEach((res) => {
          if (res.field_type == 120) {
            array.push(res)
          }
        })
        return array
      },
      openRuleDialog() {
        this.$refs.ruleList.open()
      },
      clearRule() {
        this.col.rule.name = ''
        this.col.rule.id = null
      },
      openRealityDialog(index) {
        this.colIndex = index
        this.$refs.realityList.open()
      },
      selectRule(id, title_else, title) { // 选择权限
        this.col.rule.id = id
        this.col.rule.name = title_else
      },
      selectReality(id, name) {
        this.col.link_option[this.colIndex].reality.id = id
        this.col.link_option[this.colIndex].reality.name = name
        this.realityChange(this.col.link_option[this.colIndex])
      },
      resetFieldOption() {
        this.col.field_option = []
      },
      switchList() {
        this.listChange = true
        setTimeout(() => {
          this.listChange = false
        }, 1000)
      },
      addSummaryCondition() {
        this.col.summaryConfig.summary_condition.push(_.cloneDeep(this.summaryConditionModel))
      },
      addStatisticsCondition() {
        this.col.statistics_configs.statistics_condition.push(_.cloneDeep(this.statisticsConditionModel))
      },
      deleteSummaryCondition(index) {
        this.col.summaryConfig.summary_condition.splice(index, 1)
      },
      deleteStatisticsCondition(index) {
        this.col.statistics_configs.statistics_condition.splice(index, 1)
      },
      checkColWidth(col) {
        if (col.width > 12) {
          col.width = 12
        }
      },
      addLinkOption() {
        this.col.link_option.push(_.cloneDeep(this.linkOptionModel))
      },
      deleteLinkOption(index) {
        this.col.link_option.splice(index, 1)
      },
      summaryFieldChange() {
        _(this.fieldsWithSubform).forEach((res) => {
          if (res.field_id == this.col.summaryConfig.marjor_field_id) {
            if (res.is_subform) {
              this.col.summaryConfig.is_subform = 1
            } else {
              this.col.summaryConfig.is_subform = 0
            }
            return
          }
        })
      },
      async realityChange(item) {
        if (this.beChange || this.listChange) {
          return
        }
        item.fields = []
        this.loading = true
        item.field_option = await this.getFields(item.reality.id)
        this.loading = false
      },
      getKeyOptions(form_model, key_data) {
        this.apiGet('form/models/' + form_model + '/fields?type=1').then((res) => {
          if (res.code == 200) {
            let keyOptions = []
            _(key_data).forEach((kres) => {
              _(res.data).forEach((res) => {
                if (kres == res.name) {
                  res.show_title = res.title + '(' + res.name + ')'
                  keyOptions.push(res)
                  return
                }
              })
            })
            this.keyOptions = keyOptions
          } else {
            _g.dealError(this, res)
          }
        })
      },
      async getFieldsWidthSubform() { // 获取包含子表单的控件数组
        let subformInputId = null
        _(this.fields).forEach((res) => {
          if (res.field_type == this.TYPE_SUBFORM) {
            subformInputId = res.config.model_id
            return false
          }
        })
        if (subformInputId) {
          let res = await this.apiGet(`cms/deals/fields/${subformInputId}`)
          let data = this.promiseHandler(data, res)
          _(data).forEach((field) => {
            field.is_subform = true
          })
          _.remove(data, (field) => {
            return field.field == 'id'
          })
          this.fieldsWithSubform = _.cloneDeep(this.fields)
          this.fieldsWithSubform = Array.concat(this.fieldsWithSubform, data)
        } else {
          this.fieldsWithSubform = _.cloneDeep(this.fields)
        }
      },
      setForeignOption() { // 设置初始化时，外键控件的配置选项
        if (this.col.field_type == 120) {
          _(this.fields).forEach((res) => {
            if (res.field_type == 120 && res.field_id == this.col.field_id) {
              let modelId = res.config.form_model ? res.config.form_model : this.modelId
              this.getKeyOptions(modelId, res.key_data)
              return
            }
          })
        } else {
          this.keyOptions = []
        }
      }
    },
    created() {
      if (this.col.summaryConfig.table_id) {
        this.setFieldOption(this.col.summaryConfig.table_id)
      }
      if (this.col.statistics_configs.table_id) {
        this.setFieldOption2(this.col.statistics_configs.table_id)
      }
      this.setForeignOption()
      _(this.col.link_option).forEach(async (res) => {
        if (!res.reality.id) {
          return
        }
        res.field_option = await this.getFields(res.reality.id)
      })
      this.filedOptions = this.fields
      this.getFieldsWidthSubform()
      if (this.col) {
        if (this.col.field_id && this.col.field_id != 0) {
          this.apiGet('cms/deals/foreign_fields/' + this.col.field_id).then((res) => {
            if (res.code == 200) {
              this.keyList = res.data
            }
          })
        }
      }
    },
    computed: {
      fieldSelect() {
        return this.col.is_exit == 1
      },
      isSummary() {
        return this.col.is_summary == 1
      },
      isStatistics() {
        return this.col.is_statistics == 1
      },
      showLinkConfig() {
        return this.col.deal_type == this.LINK_JUMP || this.col.deal_type == this.LINK_SENDPARAMS
      },
      disabledDown() {
        return this.col.is_visible == 0
      },
      disabledJump() {
        return this.col.is_visible == 0 || this.col.is_down == 1
      },
      isPhp() {
        return this.col.is_php == 1
      }
    },
    components: {
      ruleList,
      realityList,
      foreignConfig
    },
    watch: {
      'fields'() {
        this.getFieldsWidthSubform()
      },
      'listIndex'() {
        this.switchList()
      },
      'focusIndex'() {
        this.switchList()
      },
      'col'() {
        if (this.col.summaryConfig.table_id) {
          this.setFieldOption(this.col.summaryConfig.table_id)
        }
        this.setForeignOption()
      },
      // 选择数据表字段
      'col.is_exit'() {
        if (this.col.is_exit == 1) {
          this.col.is_summary = 0
          this.col.is_php = 0
          this.col.is_statistics = 0
          this.col.arithmetic = ''
          // this.col.show_name = ''
          // this.col.field_name = ''
        }
      },
      // 选择渲染
      'col.is_visible'() {
        if (this.listChange) {
          return
        }
        if (this.col.is_visible == 0) {
          this.col.is_down = 0
          this.col.is_jump = 0
        }
      },
      // 选择汇总
      'col.is_summary'() {
        if (this.col.is_summary == 1) {
          this.col.is_exit = 0
          this.col.is_php = 0
          this.col.is_statistics = 0
          this.col.arithmetic = ''
          // this.col.show_name = ''
          // this.col.field_name = ''
        }
      },
      // 统计运算
      'col.is_statistics'() {
        if (this.col.is_statistics == 1) {
          this.col.is_exit = 0
          this.col.is_summary = 0
          this.col.is_php = 0
        }
      },
      'col.is_php'() {
        if (this.col.is_php == 1) {
          this.col.is_exit = 0
          this.col.is_summary =
          this.col.is_statistics = 0
        }
      },
      'col.is_down'() {
        if (this.listChange) {
          return
        }
        if (this.col.is_down == 1) {
          this.col.is_jump = 0
        }
      },
      'col.is_jump'() {
        if (this.col.is_jump == 0 && !this.listChange) {
          this.beChange = true
          this.col.param = ''
          this.col.reality.name = ''
          this.col.reality.id = null
          this.col.fields = []
        }
        setTimeout(() => {
          this.beChange = false
        }, 1000)
      },
      'col.deal_type'() {
        if (this.col.deal_type == this.LINK_JUMP) {
          if (this.col.link_option.length > 1) {
            this.col.link_option = [this.col.link_option[0]]
          } else if (!this.col.link_option.length) {
            this.addLinkOption()
          }
        }
      },
      'col.arithmetic'() {
        if (this.col.arithmetic != '') {
          this.is_php = 1
          this.col.is_exit = 0
          this.col.is_summary = 0
        }
      },
      'col.field_id'() {
        this.apiGet('cms/deals/foreign_fields/' + this.col.field_id).then((res) => {
          if (res.code == 200) {
            this.keyList = res.data
          }
        })
      }
    },
    mixins: [http, modelConfig, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// colConfig.vue?5a8b15ff